
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const MetaPixel = () => {
  const location = useLocation();

  const currentUrl = `${location.pathname}${location.search}`;
  const previousUrl = useRef(currentUrl);

  useEffect(() => {
    // Initial page view is already sent by index.html.
    if (previousUrl.current === currentUrl) {
      return;
    }

    previousUrl.current = currentUrl;

    if (typeof window.fbq === "function") {
      window.fbq("track", "PageView");
    }
  }, [currentUrl]);

  return null;
};

export default MetaPixel;
